import { Tile } from 'src/components/Tile';
import styled from 'styled-components';

export const BaseCard = styled(Tile)`
  cursor: default;
  .c-title {
    font-size: 22px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.prussianBlue};
    margin-bottom: 14px;
  }

  .description {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.cflowerBlue};
    display: block;
  }

  .value {
    line-height: 1.25rem;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  .separator {
    height: 1px;
    flex: 1;
    background-color: ${({ theme }) => theme.colors.stroke};
  }
`;
